<script lang="ts">
  export let type: string;
</script>

<main>
  {#if type === 'cogs'}
    Cogwheel like canes, very angular. Very typical of Murano.
  {:else if type === 'smooth_cogs'}
    Still cogwheels, but the teeth have smoother angles. Also very typical in Murano.
  {:else if type === 'pinched_circles'}
    Like a cog, but each tooth looks like the part of a circle.
  {:else if type === 'inverted_pinched_circles'}
    Same a pinched circles but with inverted circle shape: circle parts are removed instead of being added.
  {:else if type === 'bubbles'}
    Bubbles of different sizes, which do no overlay.
  {:else if type === 'scatters'}
    Random circles of the same size, which may overlay. Exists in real Murano canes.
  {:else if type === 'scatter_pavings'}
    More or less irregular paving.
  {:else if type === 'hypotrochoids'}
      Spirograph shapes.
  {:else}
    TODO
  {/if}
</main>